"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeMatchReplaceConfiguration = exports.serializeMatchReplaceConfiguration = exports.deserializeRegex = exports.serializeRegex = void 0;
exports.applyMatchReplace = applyMatchReplace;
function applyMatchReplace(input, matchReplace) {
    let result = input;
    for (const [match, replacement] of matchReplace) {
        result = result.replace(match, replacement);
    }
    return result;
}
const serializeRegex = (regex) => ({ regexSource: regex.source, flags: regex.flags });
exports.serializeRegex = serializeRegex;
const deserializeRegex = (regex) => new RegExp(regex.regexSource, regex.flags);
exports.deserializeRegex = deserializeRegex;
const serializeMatchReplaceConfiguration = (matchReplace) => matchReplace.map(([match, result]) => [
    match instanceof RegExp ? (0, exports.serializeRegex)(match) : match,
    result
]);
exports.serializeMatchReplaceConfiguration = serializeMatchReplaceConfiguration;
const deserializeMatchReplaceConfiguration = (matchReplace) => matchReplace.map(([match, result]) => [
    typeof match !== 'string' && 'regexSource' in match
        ? (0, exports.deserializeRegex)(match)
        : match,
    result
]);
exports.deserializeMatchReplaceConfiguration = deserializeMatchReplaceConfiguration;
//# sourceMappingURL=match-replace.js.map